// OEM Partner Action Types
export const GET_OEM_PARTNERS_REQUEST = 'GET_OEM_PARTNERS_REQUEST';
export const GET_OEM_PARTNERS_SUCCESS = 'GET_OEM_PARTNERS_SUCCESS';
export const GET_OEM_PARTNERS_FAILURE = 'GET_OEM_PARTNERS_FAILURE';

export const ADD_OEM_PARTNER_REQUEST = 'ADD_OEM_PARTNER_REQUEST';
export const ADD_OEM_PARTNER_SUCCESS = 'ADD_OEM_PARTNER_SUCCESS';
export const ADD_OEM_PARTNER_FAILURE = 'ADD_OEM_PARTNER_FAILURE';

export const EDIT_OEM_PARTNER_REQUEST = 'EDIT_OEM_PARTNER_REQUEST';
export const EDIT_OEM_PARTNER_SUCCESS = 'EDIT_OEM_PARTNER_SUCCESS';
export const EDIT_OEM_PARTNER_FAILURE = 'EDIT_OEM_PARTNER_FAILURE';

export const DELETE_OEM_PARTNER_REQUEST = 'DELETE_OEM_PARTNER_REQUEST';
export const DELETE_OEM_PARTNER_SUCCESS = 'DELETE_OEM_PARTNER_SUCCESS';
export const DELETE_OEM_PARTNER_FAILURE = 'DELETE_OEM_PARTNER_FAILURE';

export const CHANGE_OEM_STATUS_REQUEST = 'CHANGE_OEM_STATUS_REQUEST';
export const CHANGE_OEM_STATUS_SUCCESS = 'CHANGE_OEM_STATUS_SUCCESS';
export const CHANGE_OEM_STATUS_FAILURE = 'CHANGE_OEM_STATUS_FAILURE';

export const GET_SCAN_TYPES_REQUEST = 'GET_SCAN_TYPES_REQUEST';
export const GET_SCAN_TYPES_SUCCESS = 'GET_SCAN_TYPES_SUCCESS';
export const GET_SCAN_TYPES_FAILURE = 'GET_SCAN_TYPES_FAILURE';

export const GET_OEM_PARTNER_NAMES_REQUEST = 'GET_OEM_PARTNER_NAMES_REQUEST';
export const GET_OEM_PARTNER_NAMES_SUCCESS = 'GET_OEM_PARTNER_NAMES_SUCCESS';
export const GET_OEM_PARTNER_NAMES_FAILURE = 'GET_OEM_PARTNER_NAMES_FAILURE';

export const GET_OEM_PARTNER_USERS_REQUEST = 'GET_OEM_PARTNER_USERS_REQUEST';
export const GET_OEM_PARTNER_USERS_SUCCESS = 'GET_OEM_PARTNER_USERS_SUCCESS';
export const GET_OEM_PARTNER_USERS_FAILURE = 'GET_OEM_PARTNER_USERS_FAILURE';